import React from 'react'
import useUUID from './use-uuid'
import useOperation from './use-operation'

export default function useOnOperationBeforeExecute (callback, dependencies = []) {
  const [uuid] = useUUID()
  const operation = useOperation()

  const internalCallback = (routeName, parameters = {}) => {
    if (typeof callback === 'function') {
      callback(routeName, parameters)
    }
  }

  React.useEffect(() => {
    operation.beforeExecute(uuid, internalCallback)

    return () => {
      operation.unsetBeforeExecuteCallback(uuid)
    }
  }, [operation, ...dependencies])
}
